import React from 'react';

const Spinner = ({ className = '', style = {} }) => {
  return (
    <div className={`loader-wrapper ${className}`} style={style}>
      <div className="loader-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export const SpinnerSmall = ({ className = '' }) => {
  return <span className={`loader-ring-small ${className}`} />;
};

export default Spinner;
